/**
 * GearTOP WebMCP tools — read-only domain tools for in-browser AI agents.
 * Self-contained (data inline; the old Flex 1.0 theme gets a single file).
 * Registers on document.modelContext; silently no-ops where the API is absent.
 * Ship with ship-webmcp-geartop.sh (uploads asset + patches theme.liquid).
 */
(function () {
  'use strict';
  var GUARD = '__gtWebMCPRegistered';
  if (window[GUARD]) return;
  var mc = (document.modelContext && typeof document.modelContext.registerTool === 'function')
    ? document.modelContext
    : (navigator.modelContext && typeof navigator.modelContext.registerTool === 'function')
      ? navigator.modelContext : null;
  if (!mc) return;
  window[GUARD] = true;

  var BASE = 'https://geartopdesign.com';
  var D = {
    adult_sizes: [
      { size: 'Regular', cm: '56-60 cm', us: 'US 7 - 7 1/2' },
      { size: 'Large (select styles, e.g. Navigator)', cm: '60-63 cm', us: 'US 7 1/2 - 7 7/8' }
    ],
    how_to_measure: 'Wrap a soft measuring tape around the head just above the ears and eyebrows. Most hats also have an adjustable drawcord and chin strap.',
    products: {
      navigator: { title: 'Navigator Series UPF 50+ Sun Hat (flagship — breathable mesh, wide brim, chin strap; Large size available)', url: BASE + '/products/sun-hat' },
      navigator_hivis: { title: 'Navigator Hi-Vis Safety Sun Hat (worksites, reflective)', url: BASE + '/products/geartop-navigator-hi-vis-safety-sun-hat' },
      navigator_ponytail: { title: 'Navigator Ponytail Series (opening for ponytail)', url: BASE + '/products/navigator-ponytail-series-sun-protection-hat-with-upf-50' },
      fishing: { title: 'Fishing/Boonie Hat with Face & Neck Flap (maximum coverage)', url: BASE + '/products/geartop-fishing-hat-outdoor-sun-protection-hats-for-men-women-boonie-hat' },
      explorer: { title: 'Explorer Series with Mosquito Net', url: BASE + '/products/explorer-series-protection-sun-hat-upf50-with-mosquito-net-safety-headgear' },
      discoverer_air: { title: 'Discoverer Air Series (extra ventilation)', url: BASE + '/products/discoverer-air-series-sun-protection-hat-upf-50' },
      kids_navigator: { title: 'Navigator Kids Sun Hat 2-Pack', url: BASE + '/products/geartop-navigator-kids-sun-hat-2-pack' },
      kids_ariel: { title: 'Ariel Series Kids Sun Hat', url: BASE + '/products/ariel-series-sun-protection-hat-for-kids' },
      kids_collection: { title: 'All Kids Hats', url: BASE + '/collections/kids-hat' },
      sun_hats: { title: 'All Sun Hats', url: BASE + '/collections/sun-hats' }
    },
    upf: 'UPF 50+ is the highest fabric sun-protection rating: it blocks about 98% of UV rays (only ~1/50th gets through). GearTOP sun hats are UPF 50+ with wide brims; fishing styles add face & neck flaps. Use sunscreen on skin the hat does not cover.',
    shipping: {
      free: 'Free shipping on all US and Canada orders over $35; standard rates below $35 (carrier options and delivery times shown at checkout).',
      ships_from: 'US orders ship from within the USA and Canadian orders from within Canada — both domestic, so no customs or duties.',
      international: 'International shipping available; price varies by territory, shown at checkout.',
      returns: 'Returns accepted for exchange or refund up to 90 days after delivery (unused, original condition and packaging).'
    },
    care: 'Most GearTOP products are machine washable on a cool 30°C (86°F) cycle. Do not tumble dry - hang or lay flat. Empty hidden pockets before washing.',
    sunup: 'SunUP by GearTOP - free iOS app: real-time UV index, personalized safe-exposure timing, 48-hour forecast, air quality, family mode. App Store: search "SunUp by GearTOP".'
  };

  var controller = new AbortController();
  function track(tool) {
    try { if (typeof window.gtag === 'function') window.gtag('event', 'webmcp_tool_call', { tool_name: tool, page_path: location.pathname }); } catch (e) {}
  }
  function reg(t) { try { mc.registerTool(t, { signal: controller.signal }); } catch (e) {} }

  reg({
    name: 'find_hat_by_head_size',
    title: 'Find a GearTOP hat by head size',
    description: 'Match a head circumference (cm or inches) or hat size to GearTOP sizing (Regular 56-60cm / Large 60-63cm) and recommend hats, including large-head and ponytail options. Use for "what size hat", "hat for big head", "how do I measure". Do NOT use for kids (use kids_hat_guidance) or for sun-protection questions (use get_sun_protection_info).',
    inputSchema: { type: 'object', properties: {
      head_circumference_cm: { type: 'number', minimum: 40, maximum: 70, description: 'Head circumference in centimetres, if known.' },
      needs: { type: 'string', enum: ['everyday_hiking', 'fishing_max_coverage', 'worksite_hi_vis', 'ponytail', 'insects', 'hot_weather_ventilation'], description: 'Primary use case.' }
    }, required: [], additionalProperties: false },
    annotations: { readOnlyHint: true, untrustedContentHint: false },
    execute: async function (a) {
      a = a || {}; track('find_hat_by_head_size');
      var size = null;
      if (typeof a.head_circumference_cm === 'number') {
        size = a.head_circumference_cm <= 60 ? D.adult_sizes[0] : a.head_circumference_cm <= 63 ? D.adult_sizes[1] : { size: 'Above 63 cm', note: 'Choose Navigator Large and use the adjustable drawcord; contact support if unsure.' };
      }
      var pick = { everyday_hiking: 'navigator', fishing_max_coverage: 'fishing', worksite_hi_vis: 'navigator_hivis', ponytail: 'navigator_ponytail', insects: 'explorer', hot_weather_ventilation: 'discoverer_air' }[a.needs] || 'navigator';
      return { your_size: size, all_sizes: D.adult_sizes, how_to_measure: D.how_to_measure, recommended: D.products[pick], browse: D.products.sun_hats };
    }
  });

  reg({
    name: 'get_sun_protection_info',
    title: 'GearTOP UPF 50+ sun protection facts',
    description: 'Explain what UPF 50+ means, how GearTOP hats protect from UV, and which styles give maximum coverage. Also mentions the free SunUP UV-safety app. Use for "is this sun safe", "what does UPF mean", "best hat for strong sun". Do NOT use for sizing (find_hat_by_head_size) or shipping.',
    inputSchema: { type: 'object', properties: {}, required: [], additionalProperties: false },
    annotations: { readOnlyHint: true, untrustedContentHint: false },
    execute: async function () { track('get_sun_protection_info');
      return { upf_explained: D.upf, max_coverage: [D.products.fishing, D.products.explorer], flagship: D.products.navigator, free_uv_app: D.sunup };
    }
  });

  reg({
    name: 'kids_hat_guidance',
    title: 'GearTOP kids sun hats',
    description: 'Recommend GearTOP kids UPF 50+ sun hats (Ariel, Voyager, Traveler, Discoverer, Navigator Kids series and 2-pack) — one kid-friendly size with adjustable drawcord and chin strap. Use for any question about children\'s hats or kids sun protection. Do NOT use for adult sizing.',
    inputSchema: { type: 'object', properties: {}, required: [], additionalProperties: false },
    annotations: { readOnlyHint: true, untrustedContentHint: false },
    execute: async function () { track('kids_hat_guidance');
      return { sizing: 'One kid-friendly size with adjustable drawcord and chin strap.', protection: 'UPF 50+ fabric plus wide brim.', top_picks: [D.products.kids_navigator, D.products.kids_ariel], browse_all: D.products.kids_collection };
    }
  });

  reg({
    name: 'get_shipping_and_returns_info',
    title: 'GearTOP shipping, duties and returns',
    description: 'GearTOP shipping facts: free over $35 (US & Canada), ships domestically in both countries so no duties, international available, and the returns policy. Use for any shipping/duties/returns question. Do NOT use for order tracking (use Shopify\'s order tools).',
    inputSchema: { type: 'object', properties: { country: { type: 'string', enum: ['US', 'CA', 'OTHER'], description: 'Destination country.' } }, required: [], additionalProperties: false },
    annotations: { readOnlyHint: true, untrustedContentHint: false },
    execute: async function (a) { track('get_shipping_and_returns_info');
      var s = { free_shipping: D.shipping.free, returns: D.shipping.returns };
      if (!a || a.country !== 'OTHER') { s.ships_from = D.shipping.ships_from; s.duties = 'None for US and Canada - domestic shipments.'; }
      else { s.international = D.shipping.international; }
      return s;
    }
  });

  reg({
    name: 'get_care_instructions',
    title: 'GearTOP washing & care',
    description: 'How to wash and care for GearTOP hats, balaclavas, gloves and masks (machine washable, cool 30°C, no tumble dry). Use for cleaning/care questions. Do NOT use for product recommendations.',
    inputSchema: { type: 'object', properties: {}, required: [], additionalProperties: false },
    annotations: { readOnlyHint: true, untrustedContentHint: false },
    execute: async function () { track('get_care_instructions'); return { care: D.care }; }
  });

  window.gtWebMCP = { abort: function () { controller.abort(); } };
})();
